import {
    Autocomplete, Box,
    Button, Card, CardContent, CardHeader, Checkbox, Container,
    DialogActions,
    DialogContent, FormControlLabel,
    FormHelperText,
    Grid,
    MenuItem, Radio, RadioGroup,
    TextField, Typography, Alert, Tooltip
} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import CommonModal from "../AdminPanel/CommonModal";
import React, {useEffect, useState} from "react";

import {semverBothParams, semverValid, validateLte, validateSingleNumber} from "../../core/utils/Validator";
import {getDuplicatesAndUniques, isEmpty} from "../../core/utils/commonUtils";
import {prepareParametersForSave} from "../../core/utils/audienceUtils";
import {useCreateCampaignMutation, useGetCampaignQuery, useUpdateCampaignMutation} from "../../core/api/campaign-api";
import {Language} from "@mui/icons-material";
import LanguageForm from "./LanguageForm";
import {AudienceSelectList} from "../Audience/AudienceSelectList";
import {DateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {v4 as uuidv4} from 'uuid';
import {useNavigate, useParams} from "react-router";
import Loading from "../../components/Common/Loading";
import SendIcon from '@mui/icons-material/Send';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CustomAttributesForm from "./CustomAttributesForm";



export default function CreateCampaignPage({open, handleDialogClose}) {

    const { id, action } = useParams(); // Получаем id из URL параметров
    const isEditMode = Boolean(id);
    const isCloneMode = Boolean(action==='clone');
    const navigate = useNavigate();

    const {
        data: campaign,
        isLoading: isLoadingCampaign,
        isError: isErrorCampaign,
        error: campaignError
    } = useGetCampaignQuery(id, {
        skip: !isEditMode // Пропускаем запрос если не в режиме редактирования
    });

    useEffect(() => {
        if (isEditMode && campaign) {
            debugger
            setSelectedAudience(campaign.audienceId || "");
            if(!isCloneMode) setUuid(campaign.id)
            setMessages(campaign.messages || [{ locale: 'en', title: '', body: '' }]);
            setCustomData(campaign.customData || {});

            let deliveryTime;
            if (Array.isArray(campaign.deliveryTime)) {
                const [year, month, day, hour, minute] = campaign.deliveryTime;
                deliveryTime = dayjs(`${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute || 0).padStart(2, '0')}:00`, 'YYYY-MM-DD HH:mm:ss').toISOString();
            } else {
                deliveryTime = dayjs.unix(campaign.deliveryTime).format('YYYY-MM-DD HH:mm:ss');
            }

            setCampaignData({
                deliveryType: campaign.deliveryType || "",
                deliveryTime: deliveryTime || new Date().toISOString(),
                title: isCloneMode ? campaign?.title + " (CLONE)" : campaign?.title,
                type: campaign.type || "",
                id: isCloneMode ? uuidv4() : campaign?.id,
                //priority: campaign.priority
            });
        }
    }, [isEditMode, campaign, isCloneMode]);

    const [uuid, setUuid] = useState(uuidv4())

    const [errorText, setErrorText] = useState(null)
    const [successText, setSuccessText] = useState(null)

    const [validationErrors, setValidationErrors] = useState({
        id: '',
        deliveryType: '',
        audience:'',
        message:'',
        title:'',
        type:''
    });

    const [createCampaign, createCampaignResponse] = useCreateCampaignMutation();
    const [updateCampaign, updateCampaignResponse] = useUpdateCampaignMutation();

    const [selectedAudience, setSelectedAudience] = useState("")

    const [messages, setMessages] = useState([{ locale: 'en', title: '', body: '' }])

    const [customData, setCustomData] = useState({})

    const [campaignData, setCampaignData] = useState({
        deliveryType: "",
        deliveryTime: dayjs().startOf('day').toISOString(),
        id: uuidv4(),
        title:"",
        type:"NOTIFICATION",
        priority:0
    })


    const selectAudience = (audience) => {
        setSelectedAudience(audience)

        if (validationErrors.audience && audience) {
            setValidationErrors({
                ...validationErrors,
                audience: ''
            });
        }
    }

    if (isEditMode && isLoadingCampaign) {
        return (
            <Loading isLoading={isLoadingCampaign} isError={campaignError} error={campaignError}></Loading>
        );
    }

    if (isEditMode && isErrorCampaign) {
        return (
            <Container>
                <Alert severity="error">
                    Failed to load campaign data: {campaignError?.message}
                </Alert>
            </Container>
        );
    }

    const validateForm = () => {
        const errors = {
            id: '',
            deliveryType: '',
            audience: '',
            message: '',
            title: '',
            type: ''
        };

        if (!campaignData.id || campaignData.id.trim() === '') {
            errors.id = 'Required field';
        } else if (campaignData.id.includes(' ')) {
            errors.id = 'Title should not contain spaces';
        }

        if (!campaignData.deliveryType || campaignData.deliveryType === '') {
            errors.deliveryType = 'Required field';
        }
        if (!campaignData.title || campaignData.title === '') {
            errors.title = 'Required field';
        }

        if (!campaignData.type || campaignData.type === '') {
            errors.type = 'Required field';
        }

        if (!selectedAudience || selectedAudience === '') {
            errors.audience = 'Required field';
        }

        for(let _m in messages) {
            if(messages[_m].body === '' || messages[_m].title === '') {
                errors.message = 'Required field';
                break
            }
        }

        setValidationErrors(errors);
        return !Object.values(errors).some(error => error !== '');
    };



    const handleSave = async (status) => {
        if (!validateForm()) {
            return;
        }

        const payload = {
            "id": campaignData.id,
            "title": campaignData.title,
            "type": campaignData.type,
            "deliveryType": campaignData.deliveryType,
            "deliveryTime": dayjs(campaignData.deliveryTime).format('YYYY-MM-DDTHH:mm:ss'),
            "status": status,
            "priority": campaignData.priority,
            "messages": messages,
            "audienceId": selectedAudience,
            "customData": customData

        }

        let response
        if(isEditMode && !isCloneMode) {
            response = await updateCampaign(payload)
        } else {
            response = await createCampaign(payload)
        }

        if(response.hasOwnProperty('error'))
            setErrorText(response.error.data.error)
        else {
            setSuccessText(true)
            navigate('/campaign');
        }



    }

    const handleFieldChange = (field, value) => {
        setCampaignData({
            ...campaignData,
            [field]: value
        })
    }

    const getTitle = () => {
        if(isCloneMode) return <h1>Clone Campaign {campaign.title}</h1>
        if(isEditMode) return <h1>Update Campaign {campaign.title}</h1>

        return <h1>Create New Campaign</h1>
    }

    const getButtonTitle = () => {
        if(isCloneMode) return "Clone"
        if(isEditMode) return "Update"
        return "Create"
    }

    const handleTitleChange = (value) => {
        setCampaignData({...campaignData, title: value});

        if (validationErrors.title) {
            setValidationErrors({
                ...validationErrors,
                title: ''
            });
        }
    }

    const handleTypeChange = (value) => {
        setCampaignData({...campaignData, type: value});

        if (value === 'SYSTEM_MESSAGE') {
            setMessages([])
            if (validationErrors.message) {
                setValidationErrors({
                    ...validationErrors,
                    type: '',
                    message: ''
                });
                return
            }
        } else {
            setMessages([{ locale: 'en', title: '', body: '' }])
        }

        if (validationErrors.type) {
            setValidationErrors({
                ...validationErrors,
                type: ''
            });
        }
    }


    return (
        <Container>

            <Box display="flex" justifyContent="space-between" alignItems="center">
                {getTitle()}
            </Box>

            <Card sx={{mb:3}}>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        1. Name and Type
                    </Typography>

                    <TextField
                        sx={{minWidth: 320}}
                        value={campaignData.title}
                        label="Title"
                        error={Boolean(validationErrors.title)}
                        helperText={validationErrors.title}
                        onChange={(e) => handleTitleChange(e.target.value)}
                    />

                    <TextField
                        select
                        sx={{ml: 2, minWidth: 220}}
                        value={campaignData.type}
                        label="Type"
                        required
                        error={Boolean(validationErrors.type)}
                        helperText={validationErrors.type}
                        onChange={(e) => handleTypeChange(e.target.value)}
                    >
                        <MenuItem value="NOTIFICATION">NOTIFICATION</MenuItem>
                        <MenuItem value="SYSTEM_MESSAGE">SYSTEM_MESSAGE</MenuItem>
                    </TextField>


                </CardContent>
            </Card>

            <Card sx={{mb:3}}>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        2. Audience
                    </Typography>


                    <AudienceSelectList
                        setSelectedAudience={selectAudience}
                        selectedAudience={selectedAudience}
                        hasError={validationErrors.audience !== ''}
                    />

                </CardContent>
            </Card>


            {campaignData.type !== 'SYSTEM_MESSAGE' && (
                <Card sx={{mb:3}}>
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            3. Message
                        </Typography>

                        <LanguageForm
                            setMessages={setMessages}
                            messages={messages}
                            hasError={validationErrors.message !== ''}
                        />

                    </CardContent>
                </Card>
            )}


            <Card>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div" sx={{display: 'flex', alignItems: 'center'}}>
                        4. Delivery schedule
                        <Tooltip title={
                            <Box sx={{ p: 1 }}>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <strong>IMMEDIATE</strong> - Отправить пуш сразу
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <strong>LOCAL_TIME</strong> - Отправить пуш по локальному времени игрока
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <strong>ACTIVE_TIME</strong> - Отправить пуш по времени максимальной активности игрока
                                </Typography>
                                <Typography variant="caption" sx={{ display: 'block', mt: 2, fontStyle: 'italic', opacity: 0.8 }}>
                                    * ACTIVE_TIME - тестовый режим,
                                    пользоваться можно, но нет метрик
                                </Typography>
                            </Box>
                        } placement="right">
                            <InfoOutlinedIcon sx={{ ml: 1, color: 'text.secondary', cursor: 'help' }} />
                        </Tooltip>
                    </Typography>


                    <RadioGroup
                        row
                        required={true}
                        value={campaignData.deliveryType}
                        onChange={(e) => handleFieldChange('deliveryType', e.target.value)}
                    >
                        <FormControlLabel value="IMMEDIATE" control={<Radio />} label="Immediate" />
                        <FormControlLabel value="LOCAL_TIME" control={<Radio />} label="Local Time" />
                        <FormControlLabel value="ACTIVE_TIME" control={<Radio />} label="Active Time" />
                    </RadioGroup>

                    {validationErrors.deliveryType && (
                        <FormHelperText error sx={{ mt: 1 }}>
                            {validationErrors.deliveryType}
                        </FormHelperText>
                    )}


                    {campaignData.deliveryType !== 'IMMEDIATE' && campaignData.deliveryType !== "" && (
                        <Box sx={{ mt: 2 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    label="Delivery Time"
                                    value={dayjs(campaignData.deliveryTime)}
                                    onChange={(newValue) => {
                                        handleFieldChange('deliveryTime', newValue.toISOString());
                                    }}
                                    format="YYYY-MM-DD HH:mm:ss"
                                    sx={{ width: '100%' }}
                                />
                            </LocalizationProvider>
                        </Box>
                    )}

                </CardContent>
            </Card>

            <Card sx={{mb:3}}>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        5. Custom Attributes
                    </Typography>

                    <CustomAttributesForm
                        customData={customData}
                        setCustomData={setCustomData}
                    />
                </CardContent>
            </Card>


            {successText===true&&<Alert severity={"success"}>
                Campaign {isEditMode?"updated":"created"}
            </Alert>}


            {errorText!==null&&<Alert sx={{mb:2}} severity={"error"}>
                {errorText}
            </Alert>}


            <LoadingButton sx={{mr:2}}  startIcon={<SendIcon />} loading={createCampaignResponse.isLoading} variant={'contained'} onClick={() => handleSave("SCHEDULED")}>
                {getButtonTitle() + " and Schedule"}
            </LoadingButton>

            <LoadingButton loading={createCampaignResponse.isLoading} variant={'outlined'} onClick={() => handleSave("DRAFT")}>
                {getButtonTitle()}
            </LoadingButton>
        </Container>
    )

}